import { MILLISECONDS } from '@chiroup/core/constants/time';
import { use } from 'react';
import { useQuery } from 'react-query';
import { CustomizationListItem } from '../components/clinical-skills/CustomizationListItem.type';
import { MeContext } from '../contexts/me.context';
import { useSandboxClinicalData } from '../contexts/sandboxClinicalData.context';
import testService from '../services/test.service';

type Props = {
  refetchOnMount?: boolean;
  ids?: number[];
  patientId?: string;
};

const useTests = ({ refetchOnMount = true, ids, patientId }: Props = {}) => {
  const sandbox = useSandboxClinicalData();
  const meContext = use(MeContext) as any;
  const queryKey = ['tests', ids || [], patientId || ''];
  const { data, isFetching } = useQuery<{
    data: CustomizationListItem[];
  }>(
    queryKey,
    () => {
      if (sandbox) return { data: [] };

      return testService.list(meContext.me.selectedClinic?.ID || -1, ids, patientId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount,
      staleTime: MILLISECONDS.inMinutes(5),
    }
  );

  return { isFetching, data };
};

export default useTests;
